import repository from "@/plugins/axios/secureClient";

const profileResource = "/profile";

export default {
  getProfile() {
    return repository.get(profileResource);
  },
  setProfile(payload) {
    return repository.put(profileResource, payload);
  },
  setLang(code) {
    return repository.put(`${profileResource}/lang`, { code });
  },
  changePassword(payload) {
    return repository.put(`${profileResource}/password`, payload);
  }
};
